import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet';
import PublicHeader from '../../components/ui/PublicHeader';
import HeroSection from './components/HeroSection';
import WeeklyContentSection from './components/WeeklyContentSection';
import StatisticsSection from './components/StatisticsSection';
import ArchivePreviewSection from './components/ArchivePreviewSection';
import FAQSection from './components/FAQSection';
import SubscribeSection from './components/SubscribeSection';
import Footer from './components/Footer';

const HomePage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const handleSubscribeClick = () => {
    const subscribeSection = document.getElementById('subscribe-section');
    if (subscribeSection) {
      subscribeSection?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  return (
    <>
      <Helmet>
        <link rel="canonical" href="https://thepsnewsletter.eu/" />
        <title>THEPS Newsletter – Erasmus Partner Search & Funding Opportunities</title>
        <meta 
          name="description" 
          content="THEPS is a partner search platform for Erasmus+ and EU projects. Subscribe to our free newsletter for funding opportunities, calls, and practical insights." 
        />
      </Helmet>
      <div className="min-h-screen bg-background">
        <PublicHeader />
        
        <main className="pt-[60px]">
          <HeroSection onSubscribeClick={handleSubscribeClick} />
          <WeeklyContentSection />
          <StatisticsSection />
          <ArchivePreviewSection />
          <FAQSection />
          <SubscribeSection />
        </main>

        <Footer />
      </div>
    </>
  );
};

export default HomePage;